var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentRounded = function SvgDocumentRounded(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 6.95833V10.2917C14.6666 13.625 13.3333 14.9583 9.99992 14.9583H5.99992C2.66659 14.9583 1.33325 13.625 1.33325 10.2917V6.29167C1.33325 2.95833 2.66659 1.625 5.99992 1.625H9.33325",
    stroke: "#5E5E73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 6.95833H11.9999C9.99992 6.95833 9.33325 6.29167 9.33325 4.29167V1.625L14.6666 6.95833Z",
    stroke: "#5E5E73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 8.96094H8.66675",
    stroke: "#5E5E73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 11.625H7.33341",
    stroke: "#5E5E73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentRounded);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjY2NjYgNi45NTgzM1YxMC4yOTE3QzE0LjY2NjYgMTMuNjI1IDEzLjMzMzMgMTQuOTU4MyA5Ljk5OTkyIDE0Ljk1ODNINS45OTk5MkMyLjY2NjU5IDE0Ljk1ODMgMS4zMzMyNSAxMy42MjUgMS4zMzMyNSAxMC4yOTE3VjYuMjkxNjdDMS4zMzMyNSAyLjk1ODMzIDIuNjY2NTkgMS42MjUgNS45OTk5MiAxLjYyNUg5LjMzMzI1IiBzdHJva2U9IiM1RTVFNzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjY2NjYgNi45NTgzM0gxMS45OTk5QzkuOTk5OTIgNi45NTgzMyA5LjMzMzI1IDYuMjkxNjcgOS4zMzMyNSA0LjI5MTY3VjEuNjI1TDE0LjY2NjYgNi45NTgzM1oiIHN0cm9rZT0iIzVFNUU3MyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC42NjY3NSA4Ljk2MDk0SDguNjY2NzUiIHN0cm9rZT0iIzVFNUU3MyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC42NjY3NSAxMS42MjVINy4zMzM0MSIgc3Ryb2tlPSIjNUU1RTczIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";